import { render, staticRenderFns } from "./billing-access.vue?vue&type=template&id=9bf58180&"
import script from "./billing-access.vue?vue&type=script&lang=js&"
export * from "./billing-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports